import React, { useState, useEffect } from "react";
import styles from "./Header.module.scss";
import previewImage from "../../Assets/images/piLogo.png";

// firebase
import { db } from "../../firebase";

// components
import { Image, Collapse } from "react-bootstrap";
import moment from "moment";

// history
import { useHistory } from 'react-router-dom'; 

// icons
import { FaSearch } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext";
import { formatFeetInches } from "../../utils/feetInches";
import { formatWeightDisplay } from "../../utils/helpers";
import { formatProfileAge } from "../../utils/age";

export default function SearchSection({ display }) {
  const { isAdmin, isSuperAdmin, getUserInfoData } = useAuth();

  const [playerProfileData, setPlayerProfileData] = useState([]);
  const [searchValue, setSearchValue] = useState(null);
  const [openList, setopenList] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    getPlayerProfiles();

    return () => {};
  }, []);

  const getPlayerProfiles = async () => {
    try {
      const response = await db.collection("player-profile").get();
      const data = response.docs.map((doc) => {
        return { id: doc.id, ...doc.data() };
      });
      // console.log(data, "response");

      let filteredData;
      if (isAdmin() || isSuperAdmin()) {
        filteredData = data;
      } else {
        filteredData = data.filter((el) => {
          if (
            el["viewing_privileges"] &&
            el["viewing_privileges"].includes(getUserInfoData().memberType)
          ) {
            return el;
          }
        });
      }

      setPlayerProfileData(filteredData);
    } catch (error) {
      console.log(error, "error");
    }
  };

  const handleSearch = (value) => {
    const filteredData = playerProfileData.filter((data) => {
      return data.Title.toLowerCase().includes(value.toLowerCase());
    });
    console.log(filteredData);
    setFilteredData(filteredData);
  };

  if (display === false) return <></>;

  return (
    <>
      <div className={styles.quickSearchAnchor}>
        <div className={styles.searchContainer}>
          <FaSearch />
          <input
            style={{
              marginLeft: "10px",
            }}
            type="text"
            placeholder="Quick Player Search"
            onChange={(e) => {
              if (e.target.value.length > 0) {
                setopenList(true);
                handleSearch(e.target.value);
              } else {
                setopenList(false);
              }
            }}
          />
        </div>

        <Collapse in={openList} className={styles.collapseStyle}>
          <div className={styles.listgroup}>
            {filteredData && filteredData.length === 0 ? (
              <div className={styles.noResultsCard}>
                <p>
                  Can&apos;t find a player?{" "}
                  <Link to="/player-profile" className={styles.inlineLink}>
                    Try Smart Search
                  </Link>{" "}
                  or{" "}
                  <Link
                    to={{
                      pathname: "/player-profile",
                      search: "?requestPlayer=true",
                    }}
                    className={styles.inlineLink}
                  >
                    Request a Player
                  </Link>
                </p>
              </div>
            ) : (
              filteredData.map((item, key) => (
                <Link
                  key={item.id}
                  to={
                    (isAdmin() || isSuperAdmin())
                      ? `/player-profile/detail/${item.id}`
                      : `/player-profile/preview/${item.id}`
                  }
                  style={{
                    textDecoration: "none",
                  }}
                >
                  <SearchList item={item} isAdmin={isAdmin} isSuperAdmin={isSuperAdmin} />
                </Link>
              ))
            )}
          </div>
        </Collapse>
      </div>
      {openList && <OverlayComponent onClickAway={() => setopenList(false)} />}
    </>
  );
}

const OverlayComponent = ({ onClickAway }) => {
  return <div onClick={onClickAway} className={styles.overlay}></div>;
};

export const SearchList = ({ item, isAdmin, isSuperAdmin }) => {
  const history = useHistory();
  
  const handleItemClick = () => {
    const destination = isAdmin() || isSuperAdmin()
      ? `/player-profile/detail/${item.id}`
      : `/player-profile/preview/${item.id}`;
    history.push(destination);
  };

  return (
    <Link
      to={
        isAdmin() || isSuperAdmin()
          ? `/player-profile/detail/${item.id}`
          : `/player-profile/preview/${item.id}`
      }
      style={{ textDecoration: 'none' }}
    >
      <div onClick={handleItemClick} className={styles.searchListItem}>
        {/* Desktop Layout — styled to align with Smart Search desktop cards */}
        <div className={styles.desktopLayout}>
          <div className={styles.quickSearchDesktopCard}>
            <div className={styles.quickSearchDesktopRow}>
              <div className={styles.quickSearchPhotoFrame}>
                <Image
                  className={styles.quickSearchPhotoImg}
                  width={56}
                  height={56}
                  rounded
                  src={item?.Headshot ? item.Headshot : previewImage}
                  alt=""
                  style={{
                    objectFit: item?.Headshot ? "cover" : "contain",
                    objectPosition: "center",
                  }}
                  onError={(e) => {
                    e.target.src = previewImage;
                    e.target.style.objectFit = "contain";
                  }}
                />
              </div>

              <div className={styles.quickSearchIdentity}>
                <h3 className={styles.quickSearchName}>
                  {item.FirstName} {item.LastName}
                </h3>
                {(item.Team === "Transfer Portal" && (isAdmin() || isSuperAdmin())) ? (
                  <p className={styles.quickSearchSecondary}>{item.Team}</p>
                ) : (
                  item.Team !== "Transfer Portal" && (
                    <p className={styles.quickSearchSecondary}>{item.Team}</p>
                  )
                )}
                <p className={styles.quickSearchHometown}>
                  {item.hometown_City || item.hometown_State_Country
                    ? (
                      <>
                        {item.hometown_City}
                        {item.hometown_City && item.hometown_State_Country ? ", " : ""}
                        {item.hometown_State_Country}
                      </>
                    )
                    : "—"}
                </p>
              </div>

              <div className={styles.quickSearchColumns}>
                <div className={styles.quickSearchField}>
                  <span className={styles.quickSearchMicroLabel}>Nationality</span>
                  <p className={styles.quickSearchValue}>
                    {item.Country ? item.Country : "--"}
                  </p>
                </div>
                <div className={styles.quickSearchField}>
                  <span className={styles.quickSearchMicroLabel}>Position</span>
                  <p className={styles.quickSearchValue}>
                    {item.Position ? item.Position : "--"}
                  </p>
                </div>
                <div className={styles.quickSearchField}>
                  <span className={styles.quickSearchMicroLabel}>Year</span>
                  <p className={styles.quickSearchValue}>
                    {item.Year ? item.Year : "--"}
                  </p>
                </div>
                <div className={styles.quickSearchField}>
                  <span className={styles.quickSearchMicroLabel}>DOB</span>
                  <p className={styles.quickSearchValue}>
                    {item.DOB ? moment(item.DOB).format("l") : "--"}
                  </p>
                </div>
                <div className={styles.quickSearchField}>
                  <span className={styles.quickSearchMicroLabel}>Age</span>
                  <p className={styles.quickSearchValue}>
                    {formatProfileAge(item.DOB, item.Age)}
                  </p>
                </div>
                <div className={styles.quickSearchField}>
                  <span className={styles.quickSearchMicroLabel}>AAU Team</span>
                  <p className={styles.quickSearchValue}>
                    {item.aauTeam ? item.aauTeam : "--"}
                  </p>
                </div>
                <div className={styles.quickSearchField}>
                  <span className={styles.quickSearchMicroLabel}>Affiliation</span>
                  <p className={styles.quickSearchValue}>
                    {item.aauAffil ? item.aauAffil : "--"}
                  </p>
                </div>
                <div className={styles.quickSearchField}>
                  <span className={styles.quickSearchMicroLabel}>Status</span>
                  <p className={styles.quickSearchValue}>
                    {item.Status !== "Undecided"
                      ? `${item.Status}: ${item.committedTeam}`
                      : item.Status}
                  </p>
                </div>
              </div>

              <div className={styles.quickSearchPiOuter}>
                <div className={styles.quickSearchPiBlock}>
                  <span className={styles.quickSearchMicroLabel}>P.I. Score</span>
                  <p
                    className={
                      (isAdmin() || isSuperAdmin()) && item.overallScore
                        ? styles.quickSearchPiValue
                        : `${styles.quickSearchPiValue} ${styles.quickSearchPiValueSoon}`
                    }
                  >
                    {(isAdmin() || isSuperAdmin()) && item.overallScore
                      ? item.overallScore
                      : "Coming Soon"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Layout */}
        <div className={styles.mobileLayout}>
          <div className={styles.playerImageContainer}>
            <Image
              width="80px"
              height="80px"
              roundedCircle
              src={item?.Headshot ? item.Headshot : previewImage}
              onError={(e) => { e.target.src = previewImage; }}
              className={styles.playerImage}
            />
          </div>
          
          <div className={styles.playerInfo}>
            <h4 className={styles.playerName}>{item.FirstName} {item.LastName}</h4>
            <p className={styles.playerTeam}>
              {item.Team === "Transfer Portal" && (isAdmin() || isSuperAdmin())
                ? item.Team
                : (item.Team !== "Transfer Portal" && item.Team)}
            </p>
            <p className={styles.playerHometown}>
              {item.hometown_City || item.hometown_State_Country
                ? (
                  <>
                    {item.hometown_City}
                    {item.hometown_City && item.hometown_State_Country ? ", " : ""}
                    {item.hometown_State_Country}
                  </>
                )
                : "—"}
            </p>
          </div>
          
          <div className={styles.additionalInfo}>
            {item.aauTeam && (
              <p className={styles.aauTeam}>{item.aauTeam}</p>
            )}
            {item.Status && (
              <p className={styles.playerStatus}>
                {item.Status !== "Undecided" 
                  ? `${item.Status}: ${item.committedTeam}` 
                  : item.Status}
              </p>
            )}
          </div>
          
          <div className={styles.projectionRange}>
            <p>Projection Range</p>
            <h4>
              {item.pRange && item.Prlow !== "" && item.Prhigh !== ""
                ? item.Prlow === item.Prhigh
                  ? item.Prhigh
                  : `${item.Prlow} to ${item.Prhigh}`
                : "-"}
            </h4>
          </div>
          
          <div className={styles.statsGrid}>
            <div className={styles.statItem}>
              <span>HT</span>
              <strong>{formatFeetInches(item.Height) || '--'}</strong>
            </div>
            <div className={styles.statItem}>
              <span>WT</span>
              <strong>{formatWeightDisplay(item.Weight)}</strong>
            </div>
            <div className={styles.statItem}>
              <span>WS</span>
              <strong>{formatFeetInches(item.Wingspan) || '--'}</strong>
            </div>
            
            <div className={styles.statItem}>
              <span>CLASS</span>
              <strong>{item.Year || '--'}</strong>
            </div>
            <div className={styles.statItem}>
              <span>HAND</span>
              <strong>{item.Hand || '--'}</strong>
            </div>
            <div className={styles.statItem}>
              <span>POS</span>
              <strong>{item.Position || '--'}</strong>
            </div>
            
            <div className={styles.statItem}>
              <span>DOB</span>
              <strong>{item.DOB ? moment(item.DOB).format("MM/DD/YY") : '--'}</strong>
            </div>
            <div className={styles.statItem}>
              <span>AGE</span>
              <strong>
                {formatProfileAge(item.DOB, item.Age)}
              </strong>
            </div>
            <div className={`${styles.statItem} ${styles.piScore}`}>
              <span>P.I. SCORE</span>
              <strong>
                {(isAdmin() || isSuperAdmin()) && item.overallScore
                  ? item.overallScore
                  : "Coming Soon"}
              </strong>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};